export function getWorkerList(search, isEmployee) {
    let { getWorkerListRequest, getWorkerListError, getWorkerListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_worker_list',
        this.createBundle('get_worker_list', { search }, this.GET, getWorkerListRequest, getWorkerListResult, getWorkerListError, isEmployee)
    )
}
